export default function convertToJson(str) {
  Object.keys(str).forEach(key => {
    try {
      str[key] = JSON.parse(str[key]);
    } catch {
      str[key] = str[key];
    }
  });
}
